import NotificationService from '@/services/NotificationService';
import TaskService from '@/services/TaskService';
import store from '../store/store';

window.axios = require('axios');

const notification = new NotificationService(window.axios);
const task = new TaskService(window.axios);

export default {
  async sendNotification(task, users, description) {
    const tempArray = [];
    const currentUser = store.state.user.informations;
    users.forEach((user) => {
      const obj = this.fillUsersArray(task, user.reference);
      tempArray.push(obj);
    });
    if (currentUser.reference != task.createdBy.createdById) {
      const obj = this.fillUsersArray(task, task.createdBy.createdById);
      tempArray.push(obj);
    }
    const status = await notification.sendTaskNotification(tempArray, description);
    return status;
  },

  fillUsersArray(task, userReference) {
    const obj = {
      dueDate: task.dueDate,
      userReference,
      taskReference: task.reference,
      createdBy: task.createdBy.createdById,
    };
    return obj;
  },

  setStatusChangedBy(task, status, user) {
    task.statusChangedBy.status = status;
    task.statusChangedBy.userReference = user.reference;
    task.statusChangedBy.firstName = user.firstName;
    task.statusChangedBy.lastName = user.lastName;
    task.statusChangedBy.timeStamp = new Date().toISOString();
  },

  async updateStatus(tsk, st, user, emp) {
    if (tsk.bulk && emp && emp.length) {
      tsk.users.forEach((u) => {
        if (u.reference == emp[0].reference) {
          u.status = st;
        }
      });
    } else {
      tsk.status = st;
      this.setStatusChangedBy(tsk, st, user);
    }
    //Updating Task
    const statusTask = await this.updateTask(tsk);
    //Updating all notifications related to that task
    const statusNotification = await this.updateTaskStatusNotification(tsk);
    let status = statusTask && statusNotification;
    return status;
  },

  async updateTask(tsk) {
    const status = await task.updateTask(tsk);
    return status.data.success;
  },

  async updateTaskStatusNotification(tsk){
    const status = await notification.updateTaskStatusNotification(tsk);
    return status.data.success;
  },

  capitalizeTitle(val) {
    let name = '';
    if (val.length == 1) {
      name = val.toUpperCase();
    } else {
      const title = val.split(' ');
      title.forEach((t, index) => {
        if (title.length == index + 1) {
          name = name.concat(`${t.charAt(0).toUpperCase() + t.slice(1)}`);
        } else {
          name = name.concat(`${t.charAt(0).toUpperCase() + t.slice(1)} `);
        }
      });
    }
    return name;
  },

  deleteSelectPureIfAny() {
    const clas = 'select-pure__select select-pure__select--multiple';
    const div = document.getElementsByClassName(clas);
    div.length ? div[0].remove() : '';
  },

  removeClassFromDiv(value) {
    const divs = document.getElementsByClassName('select-pure__option--selected');
    for (let i = 0; i < divs.length; i++) {
      if (divs[i].attributes['data-value'].value == value) {
        divs[i].classList.remove('select-pure__option--selected');
        return;
      }
    }
  },

  hideGroupAndBulkBtn(user) {
    let flag = false;
    console.log(user);
    user.permissions.forEach((p) => {
      if (p.groupReference == '_super_admin' || p.groupReference == '_in_charge') {
        flag = true;
        return flag;
      }
    });
    return flag;
  },
};
